/**
 * Directives
 * @module directives
 */
define(function (require, exports) {
    'use strict';

    var $ = require('jquery');

    // @ngInject
    exports.focusNext = function () {
        return {
            restrict: 'A',
            link: function (scope, element) {

                var formatValue = function (elementToFormat) {
                    var result = elementToFormat[0].value = elementToFormat[0].value.replace(/\s/g, '');
                    return result;
                };


                var focusNextInput = function (focusElement) {
                    if (!focusElement[0].value) {
                        return;
                    }
                    if (focusElement[0].value === ' ') {
                        formatValue(focusElement);
                        return;
                    }

                    var inputs = focusElement.parent().parent().find('input');
                    for (var i = 0; i < inputs.length; i++) {
                        if (inputs[i] === focusElement[0]) {
                            $(inputs[i + 1]).trigger('focus');
                            return;
                        }
                    }
                };


                element.bind('keyup', function (event) {
                    if (event.key != 'Tab') {
                        focusNextInput(element);
                    }
                });

                element.bind('focus', function(){ $(window).scrollTop(0); });
            }
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/focusNextInputDirective.js